<template>
  <div>
    <dashboard-page-title :showAddBtn="false" :showFilter="false" :showSearch="true" :showExportation="false">الرحلات</dashboard-page-title>

    <main-table :fields="fields" :baseURL="VUE_APP_TRANSPORTATION_LINK" :list_url="'trips'"></main-table>
  </div>
</template>
<script>
import { core } from '@/config/pluginInit'
import { VUE_APP_TRANSPORTATION_LINK } from '@/config/constant'
export default {
  name: 'processes',
  mounted () {
    core.index()
  },
  data () {
    return {
      VUE_APP_TRANSPORTATION_LINK,
      fields: [
        { label: 'رقم الرحلة', key: 'id', class: 'text-right', sortable: true },
        { label: 'حالة الرحلة', key: 'status', type: 'status', class: 'text-right' },
        { label: 'اسم السائق', key: 'driver.name', class: 'text-right' },
        { label: 'رقم السائق', key: 'driver.phone', class: 'text-right' },
        { label: 'عدد الإبل', key: 'noOfCamels', class: 'text-right' },
        { label: 'المسافة (كم)', key: 'distance', class: 'text-right' },
        { label: 'إجمالي التكلفة', key: 'price', class: 'text-right' },
        { label: 'تاريخ الرحلة', key: 'dateTime', class: 'text-right' },
        { label: 'لوحة المركبة', key: 'vehicle.plateNumber', class: 'text-right' },
        {
          label: 'التحكم',
          key: 'actions',
          class: 'text-right',
          type: 'actions',
          actions: [
            {
              text: 'عرض',
              icon: 'ri-eye-fill',
              color: 'primary',
              ifNavigate: true,
              routeName: 'showTrip',
              getParams: (item) => ({ id: item.id })
            }
          ]
        }
      ]
    }
  },
  methods: {
    addMerchant () {
      console.log('hello')
    }
  }
}
</script>
